import { Suspense, lazy } from "react";
import Loader from "../../components/Loader";
import styled from "styled-components";
import Achievements from "./sections/achievements/achievements-section";
import StoriesSection from "./sections/stories/stories-section";
import AccountabilitySection from "./sections/accountability/accountability-section";
import DonorsPartnersSection from "./sections/donors-partners/donors-partners-section";
import MediaSection from "./sections/media/media-section";
import Sitemap from "../../components/Sitemap";

const Slideshow = lazy(() => import("./sections/slideshow/slideshow-section"));
const AboutUs = lazy(() => import("./sections/about-us/about-us-section"));
// const Accountable = lazy(() => import("../components/Accountable"));
// const Achievements = lazy(() => import("../components/Achievements"));
// const Gallery = lazy(() => import("../components/Gallery"));
// const Projects = lazy(() => import("../components/Projects"));
// const Sitemap = lazy(() => import("../components/Sitemap"));
// const Story = lazy(() => import("../components/Story"));
// const Supporters = lazy(() => import("../components/Supporters"));

const Home = () => {
  return (
    <div style={{ height: "100vh", backgroundColor: "#f7f7f7" }}>
      <Suspense fallback={<Loader />}>
        <Slideshow />
        <Spacer>
          <AboutUs />
          <Achievements />
          <StoriesSection />
          <AccountabilitySection />
          <DonorsPartnersSection />
          <MediaSection />
          {/* <Achievements />
          <Story />
          <Accountable />
          <Projects />
          <Gallery />
          <Supporters /> */}
        </Spacer>
      </Suspense>
      <Sitemap />
      {/* <Sitemap /> */}
    </div>
  );
};

export default Home;

const Spacer = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  padding: 20px;
  overflow: hidden;
  margin-right: 5px;
  @media (max-width: 768px) {
    padding: 0px;
    margin-right: 0px;

    /* height: auto; */
  }
`;
